import React from 'react';

/**
 * Fairmont Golden Prague – Navigation Kiosk
 * Renders the self-contained kiosk HTML inside a full-screen iframe.
 * The HTML is served from /fairmont_kiosk.html (copied from Client/public during build).
 */
const FairmontKiosk = () => {
    return (
        <iframe
            src="/admin/fairmont_kiosk.html"
            title="Fairmont Golden Prague Kiosk"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                border: 'none',
                display: 'block',
                zIndex: 9999,
                background: '#F7F3EC',
            }}
        />
    );
};

export default FairmontKiosk;
